import React from 'react'
import { withRouter } from 'react-router-dom'
import { get, isEmpty } from 'lodash'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import {
    Container,
} from 'reactstrap'

import Form from './components/Form'

const Create = (props) => {
    const userAddressId = get(props, 'match.params.id', false)
    return(
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs
                        title="Crear dirección de envío"
                        breadcrumbItem={isEmpty(userAddressId) ? 'Crear dirección de envío' : 'Editar dirección de envío'}
                        parentLink={`/direccion-envio`}
                    />
                    <Form />
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withRouter(Create)
